import { render, staticRenderFns } from "./BadgeAlertWrapperComponent.vue?vue&type=template&id=1f1a8e7b&"
import script from "./BadgeAlertWrapperComponent.vue?vue&type=script&lang=js&"
export * from "./BadgeAlertWrapperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports